import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import Modal from "../modal-new";
import ImageUploadInput from "../inputs/image-upload";
import TagInput from "../inputs/tag-input";
import Select from "../inputs/select";
import submit from "submit-form";
import getCycleCardImagePath from "../../utils/get-cycle-card-image-path";
import SvgIcon from "../SvgIcon";

class AddCycleModal extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      name: "",
      experience: 2,
      tags: [],
      numberOfWeeks: 4,
      sessionsPerWeek: 1,
      description: "",
      submitted: false,
      video: "",
    };
    this.state = this.initialState;
    this.pushTag = this.pushTag.bind(this);
    this.removeTag = this.removeTag.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const editCycle = this.context.locals.editCycle;
    const storeType = this.context.locals.query.storeType;
    if (editCycle) {
      const {
        name,
        goals = [],
        difficulty = "Intermediate",
        numberOfWeeks = storeType !== "single-workot" ? 4 : 1,
        sessionsPerWeek = 1,
        description,
        video,
      } = editCycle;

      this.setState({
        name,
        experience: { Beginner: 1, Intermediate: 2, Expert: 3 }[difficulty],
        tags: goals,
        numberOfWeeks,
        sessionsPerWeek,
        description,
        video,
      });
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextContext.locals.query.submitError) {
      this.setState({ submitted: false });
    }
  }

  handleCycleTypeChange() {
    document.getElementById("add-cycle-form").reset();
  }

  handleSubmit(e) {
    if (this.state.submitted) {
      // Needed for avoid form submit on pressing enter when creating a new tag
      e.preventDefault();
      return;
    }
    this.setState({ submitted: true });
  }

  pushTag(tag) {
    this.setState({ tags: [...this.state.tags, tag] });
  }

  removeTag(idx) {
    const tags = this.state.tags;
    tags.splice(idx, 1);
    this.setState({ tags });
  }

  handleChange({ target }) {
    const { value } = target;
    const strings = ["name", "description", "video"];
    this.setState({
      [target.name]: strings.includes(target.name) ? value : parseInt(value),
    });
  }

  render() {
    const {
      locals: { activeUserToRequest, query, editCycle, athlete, flash },
    } = this.context;
    const {
      name,
      tags,
      experience,
      numberOfWeeks,
      sessionsPerWeek,
      description,
      video,
    } = this.state;
    const isCoachingPortal = Boolean(
      this.context.locals.pathname.includes("coaching-portal")
    );
    const [firstName, lastName] = get(activeUserToRequest, "name", "").split(
      / +/
    );

    const storeType = query.storeType || "programs";
    const isSingleWorkout = storeType === "single-workout";

    const prefixForNonTemplates = {
      programs: "Program",
      teams: "Team",
      "single-workout": "Single Workout",
    };

    const prefix = query.isTemplate
      ? "Template"
      : prefixForNonTemplates[storeType];

    let organizationQuery = ``;

    if (this.context.locals.query.organizationCoach) {
      organizationQuery = `&organizationCoach=${this.context.locals.query.organizationCoach}`;
    }

    const endpoint = editCycle
      ? `/actions/cycle/edit/${editCycle._id}?athlete=${
          athlete && athlete._id
        }&coaching=${isCoachingPortal}`
      : `/actions/cycle?proxyAthlete=${query.athlete || ""}&${
          query.isSubscription
            ? `isSubscription=true`
            : `isTemplate=${query.isTemplate}` + organizationQuery
        }&storeType=${storeType}`;

    return (
      <form
        id="add-cycle-form"
        action={endpoint}
        method="POST"
        encType="multipart/form-data"
        data-noreset
        onSubmit={this.handleSubmit}
      >
        {editCycle ? (
          <div>
            <input type="hidden" name="_id" defaultValue={editCycle._id} />
            <input
              type="hidden"
              name="tags"
              defaultValue={JSON.stringify(tags)}
            />
          </div>
        ) : (
          <div>
            <input
              type="hidden"
              name="tags"
              defaultValue={JSON.stringify(tags)}
            />
          </div>
        )}
        <Modal
          className="add-cycle-modal"
          title={`${editCycle ? "Edit" : "New"} ${prefix}`}
          toClear={["isSubscription", "cycleType", "storeType"]}
        >
          <div className="body">
            <div className={`row ${isSingleWorkout ? "!mb-2" : ""}`}>
              <div className="left">
                <div className={`group ${isSingleWorkout ? "!mb-0" : ""}`}>
                  <label>{prefix} Name </label>
                  <input
                    name="name"
                    className="text-input"
                    placeholder={`Enter a name for your ${prefix.toLowerCase()} here`}
                    value={name}
                    onChange={this.handleChange}
                  />
                </div>
                {!isSingleWorkout && (
                  <div className="group">
                    <label>Number of weeks per block</label>

                    <Select
                      name="numberOfWeeks"
                      value={numberOfWeeks}
                      onChange={(val) =>
                        this.handleChange({
                          target: { name: "numberOfWeeks", value: val },
                        })
                      }
                      options={[
                        { text: "1 week", value: 1 },
                        { text: "2 weeks", value: 2 },
                        { text: "3 weeks", value: 3 },
                        { text: "4 weeks", value: 4 },
                        { text: "5 weeks", value: 5 },
                        { text: "6 weeks", value: 6 },
                        { text: "7 weeks", value: 7 },
                        { text: "8 weeks", value: 8 },
                      ]}
                    />
                  </div>
                )}
              </div>
              {!isSingleWorkout && (
                <div className="group">
                  <label>Tags</label>
                  <TagInput
                    tags={tags}
                    pushTag={this.pushTag}
                    removeTag={this.removeTag}
                  />
                </div>
              )}
              {isSingleWorkout && (
                <div className="group">
                  <label>Video</label>

                  <div className="input-container relative">
                    <SvgIcon
                      src="/img/new-icons/link.svg"
                      classNames="absolute left-3 top-3"
                      noFilterOnLight={true}
                    />
                    <input
                      type="text"
                      value={video}
                      placeholder="Paste link for Youtube, etc"
                      name="video"
                      className="!pl-10 !pr-10 !mt-0"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              )}
            </div>

            {!isSingleWorkout && (
              <div className="row">
                <div className="group">
                  <label>Sessions per week</label>
                  <Select
                    name="sessionsPerWeek"
                    value={sessionsPerWeek}
                    onChange={(val) =>
                      this.handleChange({
                        target: { name: "sessionsPerWeek", value: val },
                      })
                    }
                    options={[
                      { text: "1 session", value: 1 },
                      { text: "2 sessions", value: 2 },
                      { text: "3 sessions", value: 3 },
                      { text: "4 sessions", value: 4 },
                      { text: "5 sessions", value: 5 },
                      { text: "6 sessions", value: 6 },
                      { text: "7 sessions", value: 7 },
                    ]}
                  />
                </div>

                <ExperienceLevel
                  experience={experience}
                  setState={(toset) => this.setState(toset)}
                />
              </div>
            )}
            {!isSingleWorkout && (
              <div className="row">
                <div className="group description-group">
                  <label>Description</label>
                  <textarea
                    name="description"
                    className="textarea-input"
                    placeholder="Enter a description for this program"
                    value={description}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="group">
                  <ImageUploadInput
                    name="image"
                    className="program-image"
                    prefix={prefix}
                    defaultValue={
                      editCycle ? getCycleCardImagePath(editCycle) : ""
                    }
                    raw
                  />
                </div>
              </div>
            )}

            {isSingleWorkout && (
              <div className="single-workout-section">
                <div className="single-workout-group">
                  <ExperienceLevel
                    experience={experience}
                    setState={(toset) => this.setState(toset)}
                  />

                  <div className="group description-group">
                    <label>Description</label>
                    <textarea
                      name="description"
                      className="textarea-input"
                      placeholder="Enter a description for this program"
                      value={description}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="group">
                  <ImageUploadInput
                    name="image"
                    className="program-image"
                    prefix={prefix}
                    defaultValue={
                      editCycle ? getCycleCardImagePath(editCycle) : ""
                    }
                    raw
                  />
                </div>
              </div>
            )}
          </div>

          <footer>
            <button
              type="button"
              data-button-type="secondary"
              data-action="cancel"
              onClick={() => {
                submit("/actions/refresh", {
                  method: "GET",
                  body: { modal: "" },
                });
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="button save"
              data-button-type="primary"
            >
              Save
            </button>
          </footer>
        </Modal>
      </form>
    );
  }
}

const ExperienceLevel = ({ setState, experience }) => {
  return (
    <div className="group">
      <label>Experience Level</label>
      <div className="gradient-range">
        <input
          type="range"
          min={1}
          max={3}
          step={1}
          value={experience || 2}
          id="experience"
          name="difficulty"
          style={{
            background: `linear-gradient(to right, var(--gradient-left) 0%, var(--gradient-right) ${
              experience === 1 ? "0" : experience === 2 ? "50" : "100"
            }%, var(--white-10) ${
              experience === 1 ? "0" : experience === 2 ? "50" : "100"
            }%)`,
          }}
          onChange={({ target: { value } }) => {
            setState({
              experience: parseInt(value),
            });
          }}
        />
        <div className="slider-label">
          <span>Beginner</span>
          <span>Expert</span>
        </div>
      </div>
    </div>
  );
};

AddCycleModal.contextTypes = { locals: PropTypes.object };

export default AddCycleModal;
